/*
 * Created by alex@hackerbay.com on 4.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import {translate} from "react-i18next";
import Stage0Welcome from "./stages/stage0-Welcome";
import StageInstalled from "./stages/stage-Installed";

import StageAppointmentSelectCalendar from "./stages/stage-AppointmentSelectCalendar";
import StageAppointmentSelectVerify from "./stages/stage-AppointmentSelectVerify";
import StageAppointmentSelectConfirm from "./stages/stage-AppointmentSelectConfirm";

import StageCallback from "./stages/stage-Callback";
import StageCallbackConfirm from "./stages/stage-CallbackConfirm";

import StageTam6000Entry from "./stages/stage-TAM6000-Entry";
import StageTam6000EntryCalendar from "./stages/stage-TAM6000-Entry-Calendar";
import StageTam6000Cancelled from "./stages/stage-TAM6000-Cancelled";
import StageTam6001Entry from "./stages/stage-TAM6001-Entry";
import StageTam6002Entry from "./stages/stage-TAM6002-Entry";
import StageTam6002EntryCalendar from "./stages/stage-TAM6002-Entry-Calendar";
import StageTam6002Apl01 from "./stages/stage-TAM6002-APL01";
import StageTam6002Apl02 from "./stages/stage-TAM6002-APL02";
import StageTam6002Apl03 from "./stages/stage-TAM6002-APL03";
import StageTam6002Apl04EntryCalendar from "./stages/stage-TAM6002-APL04-Entry-Calendar";
import StageTam6003Entry from "./stages/stage-TAM6003-Entry";
import StageTam6003EntryCalendar from "./stages/stage-TAM6003-Entry-Calendar";

/* TODO Prüfen der alten Stages - was kann raus? */
import Stage1AppointmentSelect from "./stages/stage1-AppointmentSelect";
import Stage2AppointmentSelectCalendar from "./stages/stage2-AppointmentSelectCalendar";
import Stage3PreviousTenant from "./stages/stage3-PreviousTenant";
import Stage4CheckInformation from "./stages/stage4-CheckInformation";
import Stage5CurrentStatus from "./stages/stage5-CurrentStatus";
import Stage6ConfirmAppointment from "./stages/stage6-ConfirmAppointment";
import Stage7WaitingForAppointment from "./stages/stage7-WaitingForAppointment";
import Stage8AppointmentDayPage from "./stages/stage8-AppointmentDayPage";
import Stage10SuccessPage from "./stages/stage10-SuccessPage";
import Stage12Validation from "./stages/stage12-Validation";
import Stage13Invalid from "./stages/stage13-Invalid";
import Stage14Footer from "./stages/stage14-Footer";
import Stage15HomescreenButton from "./stages/stage15-HomescreenButton";
import {getOrderStatus} from "../api/orderStatus";
import {PackageTrackingStatus} from "../packageTrackingStatus";
import Callback from "./Callback";
import CallbackConfirm from "./CallbackConfirm";
import ServerError from "./ServerError";
import LoadingPage from "./LoadingPage";
import {loadDS360Data} from "../api/ds360";
import * as React from "react";
import Stage9RouterSetupPage from "./stages/stage9-RouterSetupPage";
import Stage11InternetProblems from "./stages/stage11-InternetProblems";
import {isBrowser} from "react-device-detect";


/**
 * STAGS definition
 * @type {{APPOINTMENT_SELECT_CALENDAR: number, LOADING: number, SUCCESS: number, INTERNET_PROBLEMS: number, VALIDATION: number, ROUTER_SETUP: number, WELCOME: number, INVALID: number, APPOINTMENT_SELECT: number, CHECK_INFORMATION: number, CURRENT_STATUS: number, CONFIRM_APPOINTMENT: number, WAITING_FOR_APPOINTMENT: number, PREVIOUS_TENANT: number, APPOINTMENT_DAY: number}}
 */
/**
 * Aufbau der Stages für Check & Care - Überlegungen
 * ENTRY-Screen - TAM 6001 - ENTRY_6001 - oder als ENTRY mit Subparameter 6001?
 *
 */
const STAGES = {
    HOMESCREEN_BUTTON: 15,
    FOOTER: 14,
    VALIDATION: 12,
    INVALID: 13,
    WELCOME: 0,
    APPOINTMENT_SELECT: 1,
    APPOINTMENT_SELECT_CALENDAR: 2,
    PREVIOUS_TENANT: 3,
    CHECK_INFORMATION: 4,
    CURRENT_STATUS: 5,
    CONFIRM_APPOINTMENT: 6,
    WAITING_FOR_APPOINTMENT: 7,
    APPOINTMENT_DAY: 8,
    ROUTER_SETUP: 9,
    SUCCESS: 10,
    INTERNET_PROBLEMS: 11,
    LOADING: -1,

    // NEW STAGES C&C APP, see #507#note-13 (Excel)

        // WELCOME:                 10,         // -> bisher ist WELCOME = 0
        INSTALLED:	                20,
        SERVER_ERROR:	            5001,       // -> siehe ERROR_STATES

    // TAM6000
        TAM6000_ENTRY:	            600010,
        TAM6000_ENTRY_CALENDAR:     600012,
        TAM6000_APPOINTMENT_SELECT_CALENDAR:	600030,
        TAM6000_APPOINTMENT_SELECT_VERIFY:	600033,
        TAM6000_APPOINTMENT_SELECT_CONFIRM:	600036,
        TAM6000_CANCELLED:	        600040,
    // TAM6001
        TAM6001_ENTRY:	            600140,
        TAM6001_APPOINTMENT_SELECT_CALENDAR:	600130,
        TAM6001_APPOINTMENT_SELECT_VERIFY:	600133,
        TAM6001_APPOINTMENT_SELECT_CONFIRM:	600136,
    // TAM6002
        TAM6002_ENTRY:	            600210,
        TAM6002_ENTRY_CALENDAR:     600212,
        TAM6002_APL01:	            600240,
        TAM6002_APL02:	            600242,
        TAM6002_APL03:	            600244,
        TAM6002_APL04_ENTRY_CALENDAR:           600246,
        TAM6002_ACCESS_DENIED:	    600250,
        TAM6002_APPOINTMENT_SELECT_CALENDAR:	600230,
        TAM6002_APPOINTMENT_SELECT_VERIFY:	    600233,
        TAM6002_APPOINTMENT_SELECT_CONFIRM:	    600236,
    // TAM6003
        TAM6003_ENTRY:	            600310,
        TAM6003_ENTRY_CALENDAR:     600312,
        TAM6003_CALLBACK:	        600320,
        TAM6003_CALLBACK_CONFIRM:	600325,
        TAM6003_APPOINTMENT_SELECT_CALENDAR:	600330,
        TAM6003_APPOINTMENT_SELECT_VERIFY:	600333,
        TAM6003_APPOINTMENT_SELECT_CONFIRM:	600336,
    // TAM6004
        TAM6004_CALLBACK:	        600420,
        TAM6004_CALLBACK_CONFIRM:	600425,
    // TAM6005
        TAM6005_CALLBACK:	        600520,
        TAM6005_CALLBACK_CONFIRM:	600525,
    // TAM6006
        TAM6006_CALLBACK:           600620,
        TAM6006_CALLBACK_CONFIRM:	600625,
    // TAM6007
        TAM6007_CALLBACK:	        600720,
        TAM6007_CALLBACK_CONFIRM:	600725,
    // TAM6008
        TAM6008_CALLBACK:	        600820,
        TAM6008_CALLBACK_CONFIRM:	600825,
    // TAM6009
        TAM6009_CALLBACK:	        600920,
        TAM6009_CALLBACK_CONFIRM:	600925,
    // TAM6010
        TAM6010_CALLBACK:	        601020,
        TAM6010_CALLBACK_CONFIRM:	601025,
    // TAM6011
        TAM6011_CALLBACK:	        601120,
        TAM6011_CALLBACK_CONFIRM:	601125,
    // TAM6013
        TAM6013_CALLBACK:	        601320,
        TAM6013_CALLBACK_CONFIRM:	601325,

    LAST_DUMMY: 99999

};

/**
 * ERROR states
 * @type {{SERVER_ERROR: number, CALLBACK_CONFIRM: number, CALLBACK: number}}
 */
const ERROR_STATES = {
    CALLBACK: 5000,
    CALLBACK_CONFIRM: 5002,
    SERVER_ERROR: 5001
};

/**
 * Debugging Switch to activate Console Logging for Stages
 * @type {boolean}
 */
const DEBUG = true;


/**
 * Stage Component
 */
class Stage extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            stageElement: null
        };
        if( DEBUG ) console.log( "#########################################################################################");
        if( DEBUG ) console.log( "FNX: Stage.js / construct / props");
        if( DEBUG ) console.log(props);

    }


    /**
     * analytics tracking - report proper stage names
     * @param stage
     * @returns {Promise<void>}
     */
    logToAnalytics = async(stage) => {
        let reportStageName;
        switch (stage) {
            case STAGES.HOMESCREEN_BUTTON:
                reportStageName = "HOMESCREEN_BUTTON";
                break;
            case STAGES.FOOTER:
                reportStageName = "FOOTER";
                break;
            case STAGES.VALIDATION:
                reportStageName = "VALIDATION";
                break;
            case STAGES.INVALID:
                reportStageName = "INVALID";
                break;
            case STAGES.WELCOME:
                reportStageName = "WELCOME";
                break;
            case STAGES.APPOINTMENT_SELECT:
                reportStageName = "APPOINTMENT_SELECT";
                break;
            case STAGES.APPOINTMENT_SELECT_CALENDAR:
                reportStageName = "APPOINTMENT_SELECT_CALENDAR";
                break;
            case STAGES.PREVIOUS_TENANT:
                reportStageName = "PREVIOUS_TENANT";
                break;
            case STAGES.CHECK_INFORMATION:
                reportStageName = "CHECK_INFORMATION";
                break;
            case STAGES.CURRENT_STATUS:
                reportStageName = "WAITING_APPOINTMENT_CONFIRMATION";
                break;
            case STAGES.CONFIRM_APPOINTMENT:
                reportStageName = "CONFIRM_APPOINTMENT";
                break;
            case STAGES.WAITING_FOR_APPOINTMENT:
                reportStageName = "WAITING_FOR_APPOINTMENT";
                break;
            case STAGES.APPOINTMENT_DAY:
                reportStageName = "APPOINTMENT_DAY";
                break;
            case STAGES.ROUTER_SETUP:
                reportStageName = "ROUTER_SETUP";
                break;
            case STAGES.SUCCESS:
                reportStageName = "SUCCESS";
                break;
            case STAGES.INTERNET_PROBLEMS:
                reportStageName = "INTERNET_PROBLEMS";
                break;
            case ERROR_STATES.CALLBACK:
                reportStageName = "CALLBACK";
                break;
            case ERROR_STATES.CALLBACK_CONFIRM:
                reportStageName = "CALLBACK_CONFIRM";
                break;
            case ERROR_STATES.SERVER_ERROR:
                reportStageName = "SERVER_ERROR";
                break;
            default:
                reportStageName = "UNKNOWN";
                break;
        }

        if(stage !== STAGES.LOADING){
            var dl = {
                siteStructure: ["micropages","fixed onboarding web",reportStageName],
                loginStatus: "not logged in",
                pageType: "service",
                siteArea: "micropages",
                platformType: "responsive"
            };
            var _ddq = window._ddq || (window._ddq = []);
            _ddq.push(['pageview',dl]);
        }
    }


    /**
     * Get Stage Element to display in Frontend
     * @returns {Promise<void>}
     */
    getStageElement = async() => {

        if( DEBUG ) console.log( "#########################################################################################");
        if( DEBUG ) console.log( "FNX: Stage.js // getStageElement" );

        let element;
        let stage = this.props.stage
        this.logToAnalytics(stage);

        if( DEBUG ) console.log( "FNX: Stage.js // getStageElement // benachrichtigungPer: " + this.props.benachrichtigungPer );

		// selectedDate auswerten (entweder aus this.props.selectedDate, alternativ aus der API-Daten)
            var selectedDate = this.props.selectedDate;
            if( !selectedDate && this.props.ds360APIResult ) {
                if( DEBUG ) console.log( "FNX: Stage.js // getStageElement // get selectedDate from API" );
                selectedDate = this.props.ds360APIResult.changedDate;
            }
            if( DEBUG ) console.log( "FNX: Stage.js // getStageElement // selectedDate = " + selectedDate );

        // Main Debugging of Current Stage and API Results
        if( DEBUG ) console.log( "FNX: Debug Current Stage in getStageElement"); if( DEBUG ) console.log( {"CurrentStage": stage, "this.props.ds360APIResult": this.props.ds360APIResult } );

        switch(stage) {

             /**
             * Validation Stage
             */
            case STAGES.VALIDATION:
                if( DEBUG ) console.log( "FNX: Stage.js Stage12Validation / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage12Validation
                    nextStage={this.props.nextStage}
                    apiData={this.props.ds360APIResult.customer}
                    contactInformation={this.props.ds360APIResult.contactInformation}
                    validationCallback={this.props.validationCallback}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * Invalid Stage
             */
            case STAGES.INVALID:
                if( DEBUG ) console.log( "FNX: Stage.js Stage13Invalid / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage13Invalid
                    nextStage={this.props.nextStage}
                    apiData={this.props.ds360APIResult.customer}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;


            /** **********************************************************************************************
             *
             * STAGES.WELCOME
             *
             *********************************************************************************************** */
            case STAGES.WELCOME:
                if( DEBUG ) console.log( "#########################################################################################");
                if( DEBUG ) console.log( "FNX: Stage.js STAGES.Stage0Welcome / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage0Welcome
                    nextStage={this.props.nextStage}
                    commonSubmitCallback={this.props.commonSubmitCallback}
                    apiData={this.props.ds360APIResult.customer}
                    validationDone={this.props.validationDone}
                    saveUserDataToCCApi={this.props.saveUserDataToCCApi}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;


            case STAGES.APPOINTMENT_SELECT:
                if( DEBUG ) console.log( "FNX: Stage.js Stage1AppointmentSelect / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage1AppointmentSelect
                    nextStage={this.props.nextStage}

                    ds360APIResult={this.props.ds360APIResult}
                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            case STAGES.APPOINTMENT_SELECT_CALENDAR:
                if( DEBUG ) console.log( "FNX: Stage.js Stage2AppointmentSelectCalendar / this.props: "); if( DEBUG ) console.log( this.props );

                let availableDates;
                //If the ds360APIResult prop is set, the user is in the TT stage
                //In that case we must use the availableDates supplied in ds360APIResult
                if(this.props.ds360APIResult && Object.keys(this.props.ds360APIResult).length > 0){
                    availableDates = this.props.ds360APIResult.availableDates;
                }else{
                    availableDates = this.props.ds360APIResult.availableDates;
                }

                element = <Stage2AppointmentSelectCalendar
                    calendarSelectCallback={this.props.calendarSelectCallback}
                    availableDates={availableDates}
                    benachrichtigungPer={this.props.benachrichtigungPer}

                    ds360APIResult={this.props.ds360APIResult}
                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    onClickClose={this.props.setupOnClickClose}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            case 3:
                if( DEBUG ) console.log( "FNX: Stage.js Stage3PreviousTenant / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage3PreviousTenant
                    previousTenantSelectCallback={this.props.previousTenantSelectCallback}
                    previousStep={this.props.previousStage}
                    date={selectedDate}
                    previousTenant={this.props.ds360APIResult.previousTenant}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    onClickClose={this.props.setupOnClickClose}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            case 4:
                if( DEBUG ) console.log( "FNX: Stage.js Stage4CheckInformation / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage4CheckInformation
                    previousStep={this.props.previousStage}

                    date={selectedDate}
                    previousTenant={this.props.ds360APIResult.previousTenant}
                    address={this.props.ds360APIResult.address}
                    contactInformation={this.props.ds360APIResult.contactInformation}
                    building={this.props.ds360APIResult.building}
                    benachrichtigungPer={this.props.benachrichtigungPer}

                    saveCustomerDataCallback={this.props.saveCustomerDataCallback}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    onClickClose={this.props.setupOnClickClose}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            case 5:
                if( DEBUG ) console.log( "FNX: Stage.js Stage5CurrentStatus / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage5CurrentStatus
                    nextStage={this.props.nextStage}
                    previousStep={this.props.previousStage}

                    date={selectedDate}
                    previousTenant={this.state.previousTenant}
                    lineAddress={this.state.lineAddress}
                    contactInformation={this.state.contactInformation}
                    buildingInformation={this.state.buildingInformation}
                    ds360APIResult={this.props.ds360APIResult}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                    openHomeScreen={this.props.openHomeScreen}
                />;
                break;

            case STAGES.CONFIRM_APPOINTMENT:
                if( DEBUG ) console.log( "FNX: Stage.js Stage6ConfirmAppointment / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage6ConfirmAppointment
                    nextStage={this.props.nextStage}

                    date={selectedDate}
                    previousTenant={this.state.previousTenant}
                    lineAddress={this.state.lineAddress}
                    contactInformation={this.state.contactInformation}
                    buildingInformation={this.state.buildingInformation}
                    benachrichtigungPer={this.props.benachrichtigungPer}
                    changeAppointment={this.props.changeAppointment}
                    ds360APIResult={this.props.ds360APIResult}
                    confirmAppointment={this.props.confirmAppointment}
                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            case 7:
                if( DEBUG ) console.log( "FNX: Stage.js Stage7WaitingForAppointment / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage7WaitingForAppointment
                    callbackRequestedSuccessfully={this.props.callbackRequestedSuccessfully}
                    orderStatus={this.props.orderStatus}
                    urlIdent={this.props.urlIdent}
                    date={selectedDate}
                    previousTenant={this.state.previousTenant}
                    lineAddress={this.state.lineAddress}
                    contactInformation={this.state.contactInformation}
                    buildingInformation={this.state.buildingInformation}
                    changeAppointment={this.props.changeAppointment}
                    ds360APIResult={this.props.ds360APIResult}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;

                break;

            /**
             * Appointment Day Page "Hat alles geklappt?"
             */
            case STAGES.APPOINTMENT_DAY:
                if( DEBUG ) console.log( "FNX: Stage.js Stage8AppointmentDayPage / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage8AppointmentDayPage
                    orderStatus={this.props.orderStatus}
                    date={selectedDate}
                    nextStage={this.props.nextStage}
                    previousTenant={this.state.previousTenant}
                    lineAddress={this.state.lineAddress}
                    contactInformation={this.state.contactInformation}
                    buildingInformation={this.state.buildingInformation}
                    contactVodafoneCallback={this.props.contactVodafoneCallback}
                    ds360APIResult={this.props.ds360APIResult}
                    callbackSubmitted={this.props.callbackSubmitted}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * Router Setup Page
             */
            case 9:
                if( DEBUG ) console.log( "FNX: Stage.js Stage9RouterSetupPage / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage9RouterSetupPage
                    orderStatus={this.props.orderStatus}
                    nextStage={this.props.nextStage}
                    date={selectedDate}
                    previousTenant={this.state.previousTenant}
                    lineAddress={this.state.lineAddress}
                    contactInformation={this.state.contactInformation}
                    buildingInformation={this.state.buildingInformation}
                    contactVodafoneCallback={this.props.contactVodafoneCallback}
                    ds360APIResult={this.props.ds360APIResult}

                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * Success Page
             */
            case STAGES.SUCCESS:
                if( DEBUG ) console.log( "FNX: Stage.js Stage10SuccessPage / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage10SuccessPage
                    orderStatus={this.props.orderStatus}
                    showMeinVodafoneLogin={this.showMeinVodafoneLogin}
                    date={selectedDate}
                    previousTenant={this.state.previousTenant}
                    lineAddress={this.state.lineAddress}
                    contactInformation={this.state.contactInformation}
                    buildingInformation={this.state.buildingInformation}
                    contactVodafoneCallback={this.props.contactVodafoneCallback}
                    ds360APIResult={this.props.ds360APIResult}
                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * Footer Overlay
             */
            case STAGES.FOOTER:
                if( DEBUG ) console.log( "FNX: Stage.js Footer / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage14Footer
                    openTopBav={this.props.openTopNav}
                    urlIdent={this.props.urlIdent}
                    onClickClose={this.props.setupOnClickClose}
                    serverErrorCallback={this.props.serverErrorCallback}
                    ds360APIResult={this.props.ds360APIResult}
                />;
                break;


            /**
             * HomescreenButton Stage
             */
            case STAGES.HOMESCREEN_BUTTON:
                if( DEBUG ) console.log( "FNX: Stage.js Stage15HomescreenButton / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage15HomescreenButton
                    openTopBav={this.props.openHomeScreen}
                    urlIdent={this.props.urlIdent}
                    onClickClose={this.props.setupOnClickClose}
                    serverErrorCallback={this.props.serverErrorCallback}
                    ds360APIResult={this.props.ds360APIResult}
                />;
                break;

            /**
             * Internet Problems
             */
            case STAGES.INTERNET_PROBLEMS:
                if( DEBUG ) console.log( "FNX: Stage.js Stage11InternetProblems / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Stage11InternetProblems
                    orderStatus={this.props.orderStatus}
                    showMeinVodafoneLogin={this.showMeinVodafoneLogin}
                    date={selectedDate}
                    previousTenant={this.state.previousTenant}
                    lineAddress={this.state.lineAddress}
                    contactInformation={this.state.contactInformation}
                    buildingInformation={this.state.buildingInformation}
                    contactVodafoneCallback={this.props.contactVodafoneCallback}
                    ds360APIResult={this.props.ds360APIResult}
                    currentStage={this.props.stage}
                    serverErrorCallback={this.props.serverErrorCallback}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * Callback Overlay/Form
             */
            case ERROR_STATES.CALLBACK:
                if( DEBUG ) console.log( "FNX: Stage.js Callback / this.props: "); if( DEBUG ) console.log( this.props );
                element = <Callback
                    callbackRequestCallback={this.props.callbackRequestCallback}
                    urlIdent={this.props.urlIdent}
                    onClickClose={this.props.setupOnClickClose}
                    serverErrorCallback={this.props.serverErrorCallback}
                    ds360APIResult={this.props.ds360APIResult}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * Callback Confirmation Page after submitting Callback Form successfully
             * -> see fnx #187 / CARE-748 / CARE-824 Bestätigungsseite nach Callbackwunsch
             */
            case ERROR_STATES.CALLBACK_CONFIRM:
                if( DEBUG ) console.log( "FNX: Stage.js CallbackConfirm / this.props: "); if( DEBUG ) console.log( this.props );
                element = <CallbackConfirm
                    urlIdent={this.props.urlIdent}
                    onClickClose={this.props.setupOnClickClose}
                    serverErrorCallback={this.props.serverErrorCallback}
                    ds360APIResult={this.props.ds360APIResult}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * Server Error
             */
            case ERROR_STATES.SERVER_ERROR:
                if( DEBUG ) console.log( "FNX: Stage.js ServerError / this.props: "); if( DEBUG ) console.log( this.props );
                element = <ServerError
                    error={this.props.serverError}
                    openTopNav={this.props.openTopNav}
                />;
                break;

            /**
             * LoadingPage
             */
            case STAGES.LOADING:
                if( DEBUG ) console.log( "FNX: Stage.js LoadingPage / this.props: "); if( DEBUG ) console.log( this.props );
                element = <LoadingPage/>;
                break;



            /** **********************************************************************************************
             *
             * INSTALLED
             *
             *********************************************************************************************** */

                /**
                 * INSTALLED
                 * stage-Installed.js
                 * Line/Service is working
                 */
                case STAGES.INSTALLED:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.INSTALLED / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageInstalled
                        nextStage={this.props.nextStage}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;


            /** **********************************************************************************************
             *
             * TAM6000
             *
             *********************************************************************************************** */

                /**
                 * TAM6000 - Entry
                 * stage-TAM6000-Entry.js
                 */
                case STAGES.TAM6000_ENTRY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6000_ENTRY / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6000Entry
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        saveUserDataToCCApi={this.props.saveUserDataToCCApi}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6000 - Cancelled
                 * stage-TAM6000-Cancelled.js
                 */
                case STAGES.TAM6000_CANCELLED:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6000_CANCELLED / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6000Cancelled
                        nextStage={this.props.nextStage}
                        ds360APIResult={this.props.ds360APIResult}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6000 - Entry Calendar Stage ("neuer Versuch") - intermediate page just before calendar
                 * stage-TAM6000-Entry-Calendar.js
                 */
                case STAGES.TAM6000_ENTRY_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6000_ENTRY_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6000EntryCalendar
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6000 - APPOINTMENT_SELECT_CALENDAR
                 * stage-AppointmentSelectCalendar.js
                 */
                case STAGES.TAM6000_APPOINTMENT_SELECT_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6000_APPOINTMENT_SELECT_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectCalendar
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6000 - TAM6000_APPOINTMENT_SELECT_VERIFY
                 * stage-AppointmentSelectCalendarVerify.js
                 */
                case STAGES.TAM6000_APPOINTMENT_SELECT_VERIFY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6000_APPOINTMENT_SELECT_VERIFY / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectVerify
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        saveUserDataToCCApi={this.props.saveUserDataToCCApi}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6000 - TAM6000_APPOINTMENT_SELECT_CONFIRM
                 * stage-AppointmentSelectCalendarConfirm.js
                 */
                case STAGES.TAM6000_APPOINTMENT_SELECT_CONFIRM:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6000_APPOINTMENT_SELECT_CONFIRM / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectConfirm
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;



            /** **********************************************************************************************
             *
             * TAM6001
             *
             *********************************************************************************************** */

                /**
                 * TAM6001 - Entry
                 * stage-TAM6001-Entry.js
                 */
                case STAGES.TAM6001_ENTRY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6001_ENTRY / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6001Entry
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6001 - APPOINTMENT_SELECT_CALENDAR
                 * stage-AppointmentSelectCalendar.js
                 */
                case STAGES.TAM6001_APPOINTMENT_SELECT_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6001_APPOINTMENT_SELECT_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectCalendar
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6001 - TAM6001_APPOINTMENT_SELECT_VERIFY
                 * stage-AppointmentSelectCalendarVerify.js
                 */
                case STAGES.TAM6001_APPOINTMENT_SELECT_VERIFY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6001_APPOINTMENT_SELECT_VERIFY / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectVerify
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        saveUserDataToCCApi={this.props.saveUserDataToCCApi}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6001 - TAM6001_APPOINTMENT_SELECT_CONFIRM
                 * stage-AppointmentSelectCalendarConfirm.js
                 */
                case STAGES.TAM6001_APPOINTMENT_SELECT_CONFIRM:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6001_APPOINTMENT_SELECT_CONFIRM / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectConfirm
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

            /** **********************************************************************************************
             *
             * TAM6002
             *
             *********************************************************************************************** */

                /**
                 * TAM6002 - Entry
                 * stage-TAM6002-Entry.js
                 */
                case STAGES.TAM6002_ENTRY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_ENTRY / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6002Entry
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - Entry Calendar Stage ("neuer Versuch") - intermediate page just before calendar
                 * stage-TAM6002-Entry-Calendar.js
                 */
                case STAGES.TAM6002_ENTRY_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_ENTRY_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6002EntryCalendar
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - APL01
                 * stage-TAM6002-APL01.js
                 */
                case STAGES.TAM6002_APL01:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_APL01 / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6002Apl01
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - APL02
                 * stage-TAM6002-APL02.js
                 */
                case STAGES.TAM6002_APL02:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_APL02 / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6002Apl02
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - APL03
                 * stage-TAM6002-APL03.js
                 */
                case STAGES.TAM6002_APL03:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_APL03 / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6002Apl03
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - APL04 - Entry Calendar Stage ("neuer Versuch") - intermediate page just before calendar
                 * stage-TAM6002-APL04-Entry-Calendar.js
                 */
                case STAGES.TAM6002_APL04_ENTRY_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_APL04_ENTRY_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6002Apl04EntryCalendar
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - APPOINTMENT_SELECT_CALENDAR
                 * stage-AppointmentSelectCalendar.js
                 */
                case STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectCalendar
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - TAM6002_APPOINTMENT_SELECT_VERIFY
                 * stage-AppointmentSelectCalendarVerify.js
                 */
                case STAGES.TAM6002_APPOINTMENT_SELECT_VERIFY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_APPOINTMENT_SELECT_VERIFY / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectVerify
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        saveUserDataToCCApi={this.props.saveUserDataToCCApi}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6002 - TAM6002_APPOINTMENT_SELECT_CONFIRM
                 * stage-AppointmentSelectCalendarConfirm.js
                 */
                case STAGES.TAM6002_APPOINTMENT_SELECT_CONFIRM:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6002_APPOINTMENT_SELECT_CONFIRM / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectConfirm
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;


            /** **********************************************************************************************
             *
             * TAM6003
             *
             *********************************************************************************************** */

                /**
                 * TAM6003 - Entry
                 * stage-TAM6003-Entry.js
                 */
                case STAGES.TAM6003_ENTRY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6003_ENTRY / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6003Entry
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        ds360APIResult={this.props.ds360APIResult}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6003 - Entry Calendar Stage ("neuer Versuch") - intermediate page just before calendar
                 * stage-TAM6003-Entry-Calendar.js
                 */
                case STAGES.TAM6003_ENTRY_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6003_ENTRY_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageTam6003EntryCalendar
                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6003 - APPOINTMENT_SELECT_CALENDAR
                 * stage-AppointmentSelectCalendar.js
                 */
                case STAGES.TAM6003_APPOINTMENT_SELECT_CALENDAR:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6003_APPOINTMENT_SELECT_CALENDAR / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectCalendar
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6003 - TAM6003_APPOINTMENT_SELECT_VERIFY
                 * stage-AppointmentSelectCalendarVerify.js
                 */
                case STAGES.TAM6003_APPOINTMENT_SELECT_VERIFY:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6003_APPOINTMENT_SELECT_VERIFY / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectVerify
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        saveUserDataToCCApi={this.props.saveUserDataToCCApi}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;

                /**
                 * TAM6003 - TAM6003_APPOINTMENT_SELECT_CONFIRM
                 * stage-AppointmentSelectCalendarConfirm.js
                 */
                case STAGES.TAM6003_APPOINTMENT_SELECT_CONFIRM:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM6003_APPOINTMENT_SELECT_CONFIRM / this.props: "); if( DEBUG ) console.log( this.props );

                    availableDates = this.props.ds360APIResult.availableDates;

                    element = <StageAppointmentSelectConfirm
                        selectedDate={selectedDate}
                        calendarSelectCallback={this.props.calendarSelectCallback}
                        availableDates={availableDates}
                        benachrichtigungPer={this.props.benachrichtigungPer}
                        commonSubmitCallback={this.props.commonSubmitCallback}

                        ds360APIResult={this.props.ds360APIResult}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        onClickClose={this.props.setupOnClickClose}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;


            /** **********************************************************************************************
             *
             * Callback-TAMS - TAM 6003, TAM 6004 bis TAM 6011 & TAM 6013
             * (verwenden die identischen Stages mit z.T. abweichenden Texten)
             *
             *********************************************************************************************** */

                /**
                 * TAM60XX - Callback
                 * stage-Callback.js
                 */
                case STAGES.TAM6003_CALLBACK:
                case STAGES.TAM6004_CALLBACK:
                case STAGES.TAM6005_CALLBACK:
                case STAGES.TAM6006_CALLBACK:
                case STAGES.TAM6007_CALLBACK:
                case STAGES.TAM6008_CALLBACK:
                case STAGES.TAM6009_CALLBACK:
                case STAGES.TAM6010_CALLBACK:
                case STAGES.TAM6011_CALLBACK:
                case STAGES.TAM6013_CALLBACK:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM60XX_CALLBACK " + stage + " / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageCallback
                        callbackRequestCallback={this.props.callbackRequestCallback}
                        urlIdent={this.props.urlIdent}
                        onClickClose={this.props.setupOnClickClose}
                        serverErrorCallback={this.props.serverErrorCallback}
                        ds360APIResult={this.props.ds360APIResult}
                        openTopNav={this.props.openTopNav}
                        saveUserDataToCCApi={this.props.saveUserDataToCCApi}

                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;


                /**
                 * TAM60XX - Callback Confirm
                 * stage-CallbackConfirm.js
                 */
                case STAGES.TAM6003_CALLBACK_CONFIRM:
                case STAGES.TAM6004_CALLBACK_CONFIRM:
                case STAGES.TAM6005_CALLBACK_CONFIRM:
                case STAGES.TAM6006_CALLBACK_CONFIRM:
                case STAGES.TAM6007_CALLBACK_CONFIRM:
                case STAGES.TAM6008_CALLBACK_CONFIRM:
                case STAGES.TAM6009_CALLBACK_CONFIRM:
                case STAGES.TAM6010_CALLBACK_CONFIRM:
                case STAGES.TAM6011_CALLBACK_CONFIRM:
                case STAGES.TAM6013_CALLBACK_CONFIRM:
                    if( DEBUG ) console.log( "#########################################################################################");
                    if( DEBUG ) console.log( "FNX: Stage.js STAGES.TAM60XX_CALLBACK_CONFIRM " + stage + " / this.props: "); if( DEBUG ) console.log( this.props );
                    element = <StageCallbackConfirm
                        callbackRequestCallback={this.props.callbackRequestCallback}
                        urlIdent={this.props.urlIdent}
                        onClickClose={this.props.setupOnClickClose}
                        serverErrorCallback={this.props.serverErrorCallback}
                        ds360APIResult={this.props.ds360APIResult}
                        openTopNav={this.props.openTopNav}

                        nextStage={this.props.nextStage}
                        commonSubmitCallback={this.props.commonSubmitCallback}
                        apiData={this.props.ds360APIResult.customer}
                        validationDone={this.props.validationDone}
                        currentStage={this.props.stage}
                        serverErrorCallback={this.props.serverErrorCallback}
                        openTopNav={this.props.openTopNav}
                    />;
                    break;


            /**
             * Default
             */
            default:
                // console.log(this.props);
                throw Error("Invalid Stage "+this.props.stage);
        }

        this.setState({stageElement: element});
    };


    /**
     * componentDidMount - is invoked immediately after a component is mounted (inserted into the tree)
     * see http://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/
     */
    componentDidMount() {

        this.getStageElement();

        // prevent address bar overlaying content in mobile devices e.g. iOS
        setTimeout(function() {window.scrollTo(0, 1);}, 150);

    }


    /**
     * componentDidUpdate - is invoked immediately after updating occurs. This method is not called for the initial render.
     * callback function is a component has been updated and rendered
     * (which happens if current stage/state differs from previous stage/state)
     * see http://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/
     * @param prevProps
     * @param prevState
     */
    componentDidUpdate(prevProps, prevState) {

        if(prevProps.stage !== this.props.stage){
            this.getStageElement();
        }

        // prevent address bar overlaying content in mobile devices e.g. iOS
        setTimeout(function() {window.scrollTo(0, 1);}, 150);

    }


    /**
     * Component render - Render a React element into the DOM
     * @returns {*}
     */
    render() {
        if(!this.state.stageElement){
            return <LoadingPage />
        }
        return this.state.stageElement
    }
}

export default translate("translations")(Stage);
export {ERROR_STATES, STAGES}